import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import MainHeader from '../Components/MainHeader';
import IndexPage from '../Pages/IndexPage';
import MainPage from '../Pages/MainPage';
import SampleBookService from '../Services/SampleBookService';
import Header from '../Types/header';

const MainRouter = () => {
  const [mainHeader, setMainHeader] = useState<Header[]>([]);
  useEffect(() => {
    const getMainHeader = async () => {
      const res = await SampleBookService.getMainHeader();
      if (res.status === 'success') {
        setMainHeader(res.data.sort((a, b) => (a.index < b.index ? -1 : 1)));
      }
    };
    getMainHeader();
  }, []);

  return (
    <React.Fragment>
      <MainHeader data={mainHeader} />
      <Routes>
        <Route path='/' element={<IndexPage />} />
        <Route path='/:design' element={<MainPage />} />
      </Routes>
    </React.Fragment>
  );
};

export default MainRouter;
